import { IRowAction } from '../components/query/row-action';

export const rowActionUrls: IRowAction[] = [
  {
    resultType: 'citizen',
    displayName: 'Borger',
    url: '/gotoresource/contact?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'contact'
  },
  {
    resultType: 'socialprovidercitizen',
    displayName: 'Borger',
    url: '/gotoresource/socialprovidercitizen?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'contact'
  },
  {
    resultType: 'CimCitizen',
    displayName: 'Borger',
    url: '/gotoresource/contact?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'contact'
  },
  {
    resultType: 'citizenWithJoin',
    displayName: 'Borger',
    url: '/gotoresource/contact?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'contact'
  },
  {
    resultType: 'Activities',
    displayName: 'Aktiviteter',
    url: '/gotoresource/si_placement?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_placement'
  },
  {
    resultType: 'AccountLabourNeeds',
    displayName: 'Arbejdskraftbehov',
    url: '/company/routing/labourneed/{record.guid}',
    openNewWindow: true,
    entityType: 'Company.LabourNeeds_SearchView'
  },
  {
    resultType: 'company',
    displayName: 'Virksomhed',
    url: '/company/{record.guid}/details',
    openNewWindow: true,
    entityType: 'account'
  },
  {
    resultType: 'companyWithJoin',
    displayName: 'Virksomhed',
    url: '/company/{record.guid}/details',
    openNewWindow: true,
    entityType: 'account'
  },
  {
    resultType: 'Activities.Reimbursements',
    displayName: 'Godtgørelser',
    url: '/gotoresource/reimbursement?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_reimbursement'
  },
  {
    resultType: 'Activities.CoPayments',
    displayName: 'Egenbetalinger',
    url: '/gotoresource/co-payment?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'OfferAndActivity.CoPayment_SearchView'
  },
  {
    resultType: 'Personcontacts',
    displayName: 'Borgers kontaktpersoner',
    url: '/gotoresource/serviceprovider-si_personcontact?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_personcontact',
    universe: 'socialprovidercitizen'
  },
  {
    resultType: 'Personcontacts',
    displayName: 'Borgers kontaktpersoner',
    url: '/gotoresource/si_personcontact?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_personcontact',
    universe: 'citizen'
  },
  {
    resultType: 'Documents',
    displayName: 'Dokumenter',
    url: '/citizen/serviceprovider/{rootEntityId}/diary/document/create/{record.guid}',
    openNewWindow: true,
    entityType: 'Document',
    universe: 'socialprovidercitizen'
  },
  {
    resultType: 'Documents',
    displayName: 'Dokumenter',
    url: '/citizendocument/{record.guid}',
    openNewWindow: true,
    entityType: 'Document',
    universe: 'citizen'
  },
  {
    resultType: 'ContactGroups',
    displayName: 'Kontaktgrupper',
    url: '/deeplink/citizencontactgroup/{record.guid}',
    openNewWindow: true,
    entityType: 'si_contactgroup'
  },
  {
    resultType: 'IntegrationContracts',
    displayName: 'Kontrakter',
    url: '/citizencontract/{record.guid}',
    openNewWindow: true,
    entityType: 'JobcenterPlan.Contracts_SearchView'
  },
  {
    resultType: 'Plans',
    displayName: 'Planer',
    url: '/citizenplan/{record.guid}',
    openNewWindow: true,
    entityType: 'JobcenterPlan.Plans_SearchView'
  },
  {
    resultType: 'Plans.GoalsEsco',
    displayName: 'Mål: Stillingsbetegnelse',
    url: '/citizen/{rootEntityId}/plan/view',
    openNewWindow: true,
    entityType: 'JobcenterPlan.GoalsEsco_SearchView'
  },
  {
    resultType: 'NegativeEvents',
    displayName: 'Negative hændelser',
    url: '/negative-event/{record.guid}',
    openNewWindow: true,
    entityType: 'CitizenAvailability.NegativeEvents_SearchView'
  },
  {
    resultType: 'ContactPersons',
    displayName: 'Kontaktpersoner',
    url: '/company/routing/contact-person/{record.guid}',
    openNewWindow: true,
    entityType: 'LS.ContactPerson_SearchView'
  },
  {
    resultType: 'Appointments',
    displayName: 'Virksomhedsaftaler',
    url: '/company/routing/appointment/{record.guid}',
    openNewWindow: true,
    entityType: 'CompanyRelations.Appointments_SearchView'
  },
  {
    resultType: 'Tasks',
    displayName: 'Opgaver og aftaler',
    url: '/gotoresource/si_task?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_task'
  },
  {
    resultType: 'task',
    displayName: 'Opgaver og aftaler',
    url: '/gotoresource/si_task?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_task'
  },
  {
    resultType: 'Bookings',
    displayName: 'Planlagte samtaler',
    url: '/deeplink/citizeninterviewbooking/{tenant}.{crmHost}/{record.guid}',
    openNewWindow: true,
    entityType: 'si_task'
  },
  {
    resultType: 'PersonGroupMarkings',
    displayName: 'Persongruppemarkeringer',
    url: '/gotoresource/persongroupmarking?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'CitizenMasterData.PersonGroupMarking_SearchView'
  },
  {
    resultType: 'Cases',
    displayName: 'Sager',
    url: '/gotoresource/si_case?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_case'
  },
  {
    resultType: 'Cases.AssociateUsers',
    displayName: 'Supplerende sagsbehandlere',
    url: '/gotoresource/si_associateuser?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_associateuser'
  },
  {
    resultType: 'Cases.ResumedWork',
    displayName: 'Genoptaget arbejde',
    url: '/gotoresource/cases.resumedwork?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_resumedwork'
  },
  {
    resultType: 'Cases.BenefitExtensionAssessments',
    displayName: 'Forlængelsesvurderinger',
    url: '/gotoresource/si_benefitextensionassessment?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_benefitextensionassessment'
  },
  {
    resultType: 'Cases.ExpectedJobResumptionsForCase',
    displayName: 'Forventet tilbagevenden til job indenfor 13 uger',
    url: '/gotoresource/expectedjobresumption?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'Case.ExpectedJobResumption'
  },
  {
    resultType: 'ExternalOperatorAgreements',
    displayName: 'Anden aktør-aftaler',
    url: '/externaloperator/{record.guid}',
    openNewWindow: true,
    entityType: 'si_externaloperatoragreement'
  },
  {
    resultType: 'CompanyNotes',
    displayName: 'Notater',
    url: '/company/routing/company-note/{record.guid}',
    openNewWindow: true,
    entityType: 'CompanyRelations.CompanyNote_SearchView'
  },
  {
    resultType: 'RecruitmentRequests',
    displayName: 'Rekrutteringsanmodninger',
    url: '/efforts/company-recruitments/details/{record.guid}',
    openNewWindow: true,
    entityType: 'si_recruitmentrequest'
  },
  {
    resultType: 'RecruitmentRequests.RecruitmentRequestCandidates',
    displayName: 'Kandidatformidlinger',
    url: '/efforts/company-recruitments/details/candidate/{record.guid}',
    openNewWindow: true,
    entityType: 'si_recruitmentrequestcandidate'
  },
  {
    resultType: 'offerCreateNew',
    displayName: 'Opret nyt tilbud',
    url: '/offer-and-activity/create-offer',
    openNewWindow: true,
    entityType: 'si_offer'
  },
  {
    resultType: 'AssociateUsers',
    displayName: 'Supplerende sagsbehandlere',
    url: '/company/routing/associated-caseworker/{record.guid}',
    openNewWindow: true,
    entityType: 'Company.AssociatedCaseWorkers_SearchView'
  },
  {
    resultType: 'CompanySpecialCircumstances',
    displayName: 'Særlige forhold',
    url: '/company/routing/special-circumstance/{record.guid}',
    openNewWindow: true,
    entityType: 'Company.SpecialCircumstances_SearchView'
  },
  {
    resultType: 'CompanyTags',
    displayName: 'Tags',
    url: '/company/routing/tag/{record.guid}',
    openNewWindow: true,
    entityType: 'Company.Tags_SearchView'
  },
  {
    resultType: 'Offers',
    displayName: 'Tilbud og støttede job',
    url: '/gotoresource/si_offer?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_offer'
  },
  {
    resultType: 'Offers.OfferResources',
    displayName: 'Tilbudsressourcer',
    url: '/gotoresource/offer-resource?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'OfferAndActivity.OfferResource_SearchView'
  },
  {
    resultType: 'Offers.WaitingListSeats',
    displayName: 'Ventelistepladser',
    url: '/gotoresource/waiting-list-seat?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'OfferAndActivity.WaitingListSeat_SearchView'
  },
  {
    resultType: 'Interviews',
    displayName: 'Gennemførte samtaler',
    url: '/deeplink/citizeninterview/{record.guid}',
    openNewWindow: true,
    entityType: 'si_interview'
  },
  {
    resultType: 'AvailabilityAssessments',
    displayName: 'Rådighedsvurderinger',
    url: '/assessment/{record.guid}',
    openNewWindow: true,
    entityType: 'CitizenAvailability.NegativeEvents_SearchView'
  },
  {
    resultType: 'Activities.Evaluations',
    displayName: 'Evalueringer',
    url: '/gotoresource/si_evaluation?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_evaluation'
  },
  {
    resultType: 'PartialRecoveries',
    displayName: 'Delvise raskmeldinger',
    url: '/gotoresource/partialrecoveries?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_partialrecovery'
  },
  {
    resultType: 'Cases.PartialRecoveriesForCase',
    displayName: 'Delvise raskmeldinger',
    url: '/gotoresource/partialrecoveries?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'si_partialrecovery'
  },
  {
    resultType: 'journalnote',
    displayName: 'Journal note',
    url: '/citizenjournalnote/{record.guid}',
    openNewWindow: true,
    entityType: 'si_journalnote'
  },
  {
    resultType: 'ResumedWork',
    displayName: 'Genoptaget arbejde',
    url: '/deeplink/case/resumedwork/{record.guid}',
    openNewWindow: true,
    entityType: 'si_resumedwork'
  },
  {
    resultType: 'CvExperiences',
    displayName: 'CV: Erfaringer',
    url: '/deeplink/jobsearch/experience/{record.guid}',
    openNewWindow: true,
    entityType: 'si_cv_experience'
  },
  {
    resultType: 'CvJobgoals',
    displayName: 'CV: Jobmål',
    url: '/deeplink/jobsearch/jobgoal/{record.guid}',
    openNewWindow: true,
    entityType: 'si_cv_jobgoal'
  },
  {
    resultType: 'CvEducations',
    displayName: 'CV: Uddannelser',
    url: '/deeplink/jobsearch/education/{record.guid}',
    openNewWindow: true,
    entityType: 'si_cv_education'
  },
  {
    resultType: 'CvLanguageProficiencies',
    displayName: 'CV: Sprogfærdigheder',
    url: '/deeplink/jobsearch/languageproficiency/{record.guid}',
    openNewWindow: true,
    entityType: 'si_languageproficiency'
  },
  {
    resultType: 'CvExperiences',
    displayName: 'CV: Erfaringer',
    url: '/deeplink/jobsearch/experience/{record.guid}',
    openNewWindow: true,
    entityType: 'jobsearch.Experience_SearchView'
  },
  {
    resultType: 'CvQualifications',
    displayName: 'CV: Kvalifikationer',
    url: '/deeplink/jobsearch/qualification/{record.guid}',
    openNewWindow: true,
    entityType: 'jobsearch.Qualification_SearchView'
  },
  {
    resultType: 'CvDriversLicenses',
    displayName: 'CV: Kørekort',
    url: '/deeplink/jobsearch/driverslicense/{record.guid}',
    openNewWindow: true,
    entityType: 'jobsearch.DriversLicense_SearchView'
  },
  {
    resultType: 'CvJobgoals',
    displayName: 'CV: Jobmål',
    url: '/deeplink/jobsearch/jobgoal/{record.guid}',
    openNewWindow: true,
    entityType: 'jobsearch.JobTarget_SearchView'
  },
  {
    resultType: 'CvEducations',
    displayName: 'CV: Uddannelser',
    url: '/deeplink/jobsearch/education/{record.guid}',
    openNewWindow: true,
    entityType: 'jobsearch.Education_SearchView'
  },
  {
    resultType: 'CvLanguageProficiencies',
    displayName: 'CV: Sprogfærdigheder',
    url: '/deeplink/jobsearch/languageproficiency/{record.guid}',
    openNewWindow: true,
    entityType: 'jobsearch.LanguageProficiency_SearchView'
  },
  {
    resultType: 'CvCertificationsInfo',
    displayName: 'CV: Certificeringer',
    url: '/deeplink/jobsearch/certifications/{record.guid}',
    openNewWindow: true,
    entityType: 'jobsearch.CertificationsInfo_SearchView'
  },
  {
    resultType: 'CvItExperiencesInfo',
    displayName: 'CV: IT-erfaring',
    url: '/deeplink/jobsearch/itexperiences/{record.guid}',
    openNewWindow: true,
    entityType: 'jobsearch.ItExperiencesInfo_SearchView'
  },
  {
    resultType: 'CvCoursesInfo',
    displayName: 'CV: Kurser',
    url: '/deeplink/jobsearch/courses/{record.guid}',
    openNewWindow: true,
    entityType: 'jobsearch.CoursesInfo_SearchView'
  },
  {
    resultType: 'JoblogJobSearch',
    displayName: 'Joblogs',
    url: '/deeplink/jobsearch/joblog/{record.guid}',
    openNewWindow: true,
    entityType: 'jobsearch.Joblog_SearchView'
  },
  {
    resultType: 'RecruitmentRequestCandidates',
    displayName: 'Kandidatformidlinger',
    url: '/efforts/company-recruitments/details/candidate/{record.guid}',
    openNewWindow: true,
    entityType: 'si_recruitmentrequestcandidate'
  },
  {
    resultType: 'Absences',
    displayName: 'Fravær',
    url: '/absence/{record.guid}',
    openNewWindow: true,
    entityType: 'CitizenAvailability.Absences_SearchView'
  },
  {
    resultType: 'CitizenExemptions',
    displayName: 'Fritagelser',
    url: '/gotoresource/citizen-exemption?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: 'CitizenAvailability.Exemptions_SearchView'
  },
  {
    resultType: 'Nuphs',
    displayName: 'Underretninger',
    url: '/gotoresource/nuph?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'UnemploymentBenefit.Nuph_SearchView'
  },
  {
    resultType: 'Nuphs.NuphResponses',
    displayName: 'A-Kassens svar',
    url: '/gotoresource/nuph-response?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'UnemploymentBenefit.NuphResponse_SearchView'
  },
  {
    resultType: 'JobAds',
    displayName: 'Jobannoncer',
    url: '/gotoresource/jobad?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'CompanyRecruitment.JobAds'
  },
  {
    resultType: 'Cases.Grants',
    displayName: 'Bevillinger',
    url: '/gotoresource/citizen-grant?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: 'Grant'
  },
  {
    resultType: 'Cases.Assessments',
    displayName: 'Støttevurderinger',
    url: '/gotoresource/citizen-assessment?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: 'Assessment'
  },
  {
    resultType: 'Assignments',
    displayName: 'Bestillinger',
    url: '/gotoresource/citizen-assignment?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[ServiceProvider].Assignment_SearchView'
  },
  {
    resultType: 'Assignments.InterventionObjectives',
    displayName: 'Indsatsmål',
    url: '/gotoresource/intervention-objective?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[ServiceProvider].InterventionObjective_SearchView',
    universe: 'citizen'
  },
  {
    resultType: 'Assignments.InterventionObjectives',
    displayName: 'Indsatsmål',
    url: '/gotoresource/serviceprovider-intervention-objective?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[ServiceProvider].InterventionObjective_SearchView',
    universe: 'socialprovidercitizen'
  },
  {
    resultType: 'Assignments.PartialObjectives',
    displayName: 'Udførers delmål',
    url: '/gotoresource/follow-up-on-efforts?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[ServiceProvider].PartialObjective_SearchView'
  },
  {
    resultType: 'Activities.StatusNotes',
    displayName: 'Status på bestilling',
    url: '/gotoresource/authority-statusnote?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[ServiceProvider].ServiceProviderInterventionObjectiveStatus_SearchView',
    universe: 'citizen'
  },
  {
    resultType: 'Assignments.StatusNotes',
    displayName: 'Status på bestilling',
    url: '/gotoresource/serviceprovider-statusnote?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[ServiceProvider].ServiceProviderInterventionObjectiveStatus_SearchView',
    universe: 'socialprovidercitizen'
  },
  {
    resultType: 'Activities.InterventionObjectives',
    displayName: 'Indsatsmål',
    url: '/gotoresource/intervention-objective?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[ServiceProvider].InterventionObjective_SearchView',
    universe: 'citizen'
  },
  {
    resultType: 'Activities.InterventionObjectives',
    displayName: 'Indsatsmål',
    url: '/gotoresource/serviceprovider-intervention-objective?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[ServiceProvider].InterventionObjective_SearchView',
    universe: 'socialprovidercitizen'
  },
  {
    resultType: 'Activities.Assignments',
    displayName: 'Bestillinger',
    url: '/gotoresource/activities-assignment?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[ServiceProvider].Assignment_SearchView'
  },
  {
    resultType: 'DiaryNotes',
    displayName: 'Dagbogsnotater',
    url: '/gotoresource/citizen-diarynote?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: 'CitizenJournal.DiaryNotes_SearchView'
  },
  {
    resultType: 'OutboxItems',
    displayName: 'Forsendelser',
    url: '/citizen/{rootEntityId}/communication',
    openNewWindow: true,
    entityType: 'ls.OutboxItem_SearchView'
  },
  {
    resultType: 'BenefitRates',
    displayName: 'Ydelsessatser',
    url: '/citizen/{rootEntityId}/details',
    openNewWindow: true,
    entityType: 'JobnetRelations.BenefitRate_SearchView'
  },
  {
    resultType: 'ClarificationRights',
    displayName: 'Afklaringsret',
    url: '/gotoresource/citizen-clarification-right?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[Case].ClarificationRight_SearchView'
  },
  {
    resultType: 'Rulings',
    displayName: 'Afgørelser',
    url: '/gotoresource/citizen-ruling?resourceId={record.guid}&rootEntityId={rootEntityId}',
    openNewWindow: true,
    entityType: '[Grant].Ruling_SearchView'
  },
  {
    resultType: 'Plans.EducationRetentions',
    displayName: 'Støttebehov',
    url: '/citizen/{rootEntityId}/education-plan/edit',
    openNewWindow: true,
    entityType: 'JobcenterPlan.EducationRetentions_SearchView'
  },
  {
    resultType: 'Screenings',
    displayName: 'Screeninger',
    url: '/citizen/{rootEntityId}/communication',
    openNewWindow: true,
    entityType: 'Screening.Screening_SearchView'
  },
  {
    resultType: 'SelfServiceGuidances',
    displayName: 'Selvbetjent vejledninger',
    url: '/citizen/{rootEntityId}/communication',
    openNewWindow: true,
    entityType: 'Screening.SelfServiceGuidance_SearchView'
  },
  {
    resultType: 'SurveyResponses',
    displayName: 'Forum spørgeskemaer',
    url: '/citizen/{rootEntityId}/communication',
    openNewWindow: true,
    entityType: 'CitizenDialog.Survey_SearchView'
  },
  {
    resultType: 'SurveyResponses.Answers',
    displayName: 'Forum besvarelser',
    url: '/citizen/{rootEntityId}/communication',
    openNewWindow: true,
    entityType: 'CitizenDialog.Answer_SearchView'
  },
  {
    resultType: 'Cases.MedicalRequests',
    displayName: 'Lægeanmodninger',
    url: '/citizen/authority/{rootEntityId}/medical-collaboration/medical-request/{record.guid}',
    openNewWindow: true,
    entityType: 'MedicalCollaboration.RequestForm_SearchView',
    universe: 'citizen'
  },
  {
    resultType: 'MedicalRequests',
    displayName: 'Lægeanmodninger',
    url: '/citizen/serviceprovider/{rootEntityId}/medical-collaboration/medical-request/{record.guid}',
    openNewWindow: true,
    entityType: 'MedicalCollaboration.ServiceProviderRequestForm_SearchView',
    universe: 'socialprovidercitizen'
  },
  {
    resultType: 'Cases.CorrespondenceMessages',
    displayName: 'Korrespondancemeddelelser',
    url: '/citizen/authority/{rootEntityId}/medical-collaboration/correspondence/{record.guid}',
    openNewWindow: true,
    entityType: 'MedicalCollaboration.CorrespondenceMessage_SearchView',
    universe: 'citizen'
  },
  {
    resultType: 'CorrespondenceMessages',
    displayName: 'Korrespondancemeddelelser',
    url: '/citizen/serviceprovider/{rootEntityId}/medical-collaboration/correspondence/{record.guid}',
    openNewWindow: true,
    entityType: 'MedicalCollaboration.ServiceProviderCorrespondenceMessage_SearchView',
    universe: 'socialprovidercitizen'
  },
  {
    resultType: 'Courses',
    displayName: 'Hold',
    url: '/attendance/courses/course/{record.guid}',
    openNewWindow: true,
    entityType: 'Attendance.Course_SearchView'
  },
  {
    resultType: 'Courses.Lessons',
    displayName: 'Lektion',
    url: '/attendance/lessons/lesson/{record.guid}',
    openNewWindow: true,
    entityType: 'Attendance.Lesson_SearchView'
  },
  {
    resultType: 'Courses.CourseLessons',
    displayName: 'Lektion',
    url: '/attendance/lessons/lesson/{record.guid}',
    openNewWindow: true,
    entityType: 'Attendance.Lesson_SearchView'
  },
  {
    resultType: 'Courses.CourseLessons.LessonEducators',
    displayName: 'Undervisere på lektioner',
    url: '/gotoresource/lesson-educator?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'Attendance.LessonEducator_SearchView'
  },
  {
    resultType: 'Courses.CourseEducators',
    displayName: 'Undervisere på hold',
    url: '/gotoresource/course-educator?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'Attendance.CourseEducator_SearchView'
  },
  {
    resultType: 'Educators',
    displayName: 'Undervisere',
    url: '/attendance/educators/educator/{record.guid}',
    openNewWindow: true,
    entityType: 'Attendance.Educator_SearchView'
  },
  {
    resultType: 'CourseEnrollments',
    displayName: 'Fremmødeforløb',
    url: '/attendance/{rootEntityId}/course-enrollment/{record.guid}',
    openNewWindow: true,
    entityType: 'Attendance.CourseEnrollment_SearchView'
  },
  {
    resultType: 'CourseEnrollmentsWithLessons',
    displayName: 'Fremmødeforløb',
    url: '/attendance/{rootEntityId}/course-enrollment/{record.guid}',
    openNewWindow: true,
    entityType: 'Attendance.CourseEnrollment_SearchView'
  },
  {
    resultType: 'CourseEnrollmentsWithLessons.Lessons',
    displayName: 'Protokol',
    url: '/gotoresource/citizenlesson?resourceId={record.guid}',
    openNewWindow: true,
    entityType: 'Attendance.CitizenLesson_SearchView'
  },
  {
    resultType: 'CounselingInquiries',
    displayName: 'Henvendelser – åben rådgivning',
    url: '/citizen/{rootEntityId}/counseling-inquiry/{record.guid}',
    openNewWindow: true,
    entityType: 'Assessment.CounselingInquiry_SearchView',
    universe: 'citizen'
  }
];
